import { connect } from "react-redux";
import { bindActionCreators, Dispatch, AnyAction } from "@reduxjs/toolkit";
import Documentation from "../../../pages/Profile/Documentation/Documentation";
import { DocumentationContainerProps } from "../../../interfaces/containers";

function mapStateToProps(state: DocumentationContainerProps) {
    return{
        user: state.auth.user
    }
}

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>) => {
    return bindActionCreators({
        
    }, dispatch)
};

export default connect(mapStateToProps, mapDispatchToProps)(Documentation);